import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_IMAGE_DETAILS_QUERY_KEY = 'security-image-details';

export const getImageDetailsQueryKey = ({ tagId }: { tagId: string }) =>
  [SECURITY_IMAGE_DETAILS_QUERY_KEY, tagId] as const;

const getImageDetailsQueryOptions = ({
  tagId,
  enabled = true,
}: {
  tagId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getImageDetailsQueryKey({ tagId }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getImageDetails({
        tagId,
      });
      return data;
    },
    enabled,
  });

export const useImageDetailsQuery = ({
  tagId,
  enabled = true,
}: {
  tagId: string;
  enabled?: boolean;
}) => {
  const {
    isLoading,
    data: details,
    error,
    refetch,
  } = useQuery(getImageDetailsQueryOptions({ tagId, enabled }));

  return { isLoading, details, error, refetch };
};
